import React, { Component, PropTypes } from 'react';
import { Field, FieldArray } from 'redux-form';
import SpecializationField from 'profile/containers/specialization_field';


export default class EditSpecializations extends Component {

  renderControls({ fields, meta, formTouched }) {
    const { error, touched } = meta;

    return (<div>
      { fields.map(input => <Field key={input} name={input} component={SpecializationField}/>) }

      {/* FieldArrays don't get marked as `touched` upon submit, therefore we need
          to rely on `formTouched` too. */}
      { error && (touched || formTouched) && <span className="input-error">{error}</span> }

      <button className="btn btn-secondary btn-sm btn-add-specialization"
          onClick={(e) => {e.preventDefault(); fields.push(' ');}}>
        Add
      </button>
    </div>);
  }

  render() {
    const { isClient, formTouched } = this.props;

    if (isClient) {
      return null;
    }

    return (
      <div className="profile-specializations">
        <h4>Specializations</h4>
        <FieldArray
          name="specializations"
          component={this.renderControls}
          formTouched={formTouched}
        />
      </div>);
  }
}

EditSpecializations.propTypes = {
  isClient: PropTypes.bool,
  formTouched: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./profile/components/edit_specializations.jsx